import { FileDiff } from "@pierre/diffs/react"
import { parseDiffFromFile } from "@pierre/diffs"
import { useIslandProps } from "@archipelago-js/react"
import React, { useMemo } from "react"

interface RawDiffViewerProps {
  leftText: string
  rightText: string
  leftLabel: string
  rightLabel: string
  language?: string
}

export default function RawDiffViewer() {
  const { props } = useIslandProps<RawDiffViewerProps>()

  const fileDiff = useMemo(() => {
    if (!props.leftText && !props.rightText) return null

    const ext = props.language || "json"
    return parseDiffFromFile(
      { name: `${props.leftLabel || "left"}.${ext}`, contents: props.leftText || "" },
      { name: `${props.rightLabel || "right"}.${ext}`, contents: props.rightText || "" }
    )
  }, [props.leftText, props.rightText, props.leftLabel, props.rightLabel, props.language])

  if (!fileDiff) {
    return (
      <div style={{ padding: "1rem", color: "#6b7280", fontSize: "0.875rem" }}>
        No content available for raw diff.
      </div>
    )
  }

  return (
    <div style={{ border: "1px solid #e5e7eb", borderRadius: "0.5rem", overflow: "hidden" }}>
      <FileDiff fileDiff={fileDiff} />
    </div>
  )
}
